import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead, seoHeadFromPage } from "@/config/seoHead";
import { buildTitle } from "@/config/seoTitles";
import { scrapedPageQueryOptions } from "@/hooks/useScrapedPage";
import { lookupSlug, notFoundUnlessRedirected } from "@/lib/slugGuards";

const ReportArticlePage = lazy(() => import("@/pages/ReportArticle"));

export const Route = createFileRoute("/rapporter/$slug")({
  loader: async ({ params, context }) => {
    // useContent drar in de statiska nyhets- och rapportarkiven – ladda dem bara här.
    const { monthlyReportQueryOptions } = await import("@/hooks/useContent");
    const path = `/rapporter/${params.slug}`;
    const report = await lookupSlug(() => context.queryClient.ensureQueryData(monthlyReportQueryOptions(params.slug)));
    if (report) return { report, page: null };
    const page = await lookupSlug(() => context.queryClient.ensureQueryData(scrapedPageQueryOptions(path)));
    // Finns varken i arkivet eller bland de dynamiska sidorna: riktig 404.
    // (undefined = uppslagningen misslyckades – rendera hellre än att ge en falsk 404.)
    if (report === null && page === null) await notFoundUnlessRedirected(path);
    return { report: null, page: page ?? null };
  },
  head: ({ params, loaderData }) => {
    const path = `/rapporter/${params.slug}`;
    if (loaderData?.report) {
      return seoHead(path, {
        title: buildTitle(loaderData.report.title, "article"),
        description: loaderData.report.summary,
        ogType: "article",
      });
    }
    return seoHeadFromPage(path, loaderData?.page, { ogType: "article" });
  },
  component: () => <ReportArticlePage />,
});
